import { Inject, Injectable } from '@angular/core';
import { APP_ENVIRONMENT } from '@shared/providers/environment.provider';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { Environment } from '../../types/environment';
import { InvoiceProcess } from '../../types/invoice-process';

@Injectable({
  providedIn: 'root',
})
export class InvoiceProcessingService {
  readonly API = `${this.env.apiUrl}/invoiceProcessing`;

  constructor(
    @Inject(APP_ENVIRONMENT) private readonly env: Environment,
    private readonly http: HttpClient,
  ) {}

  getByOrderId(orderId: number) {
    return this.http
      .get<InvoiceProcess[]>(`${this.API}/getByOrderId`, {
        params: {
          orderId,
        },
      })
      .pipe(map(processes => processes.reverse()));
  }

  getByCargoId(cargoId: number) {
    return this.http.get<InvoiceProcess[]>(`${this.API}/getByCargoId`, {
      params: {
        cargoId,
      },
    });
  }

  getAccounting() {
    return this.http.get<InvoiceProcess[]>(`${this.API}/getAccounting`);
  }
}
